import { issuesIcon } from './../assets/icons/IssuesIcon'
import { locationsIcon } from 'assets/icons/LocationsIcon'
import { FolderIcon } from '../assets/icons/FolderIcon'
import { inventoryIcon } from '../assets/icons/InventoryIcon'
import { machineryIcon } from '../assets/icons/MachineryIcon'
import { NutIcon } from '../assets/icons/NutIcon'
import { TasksIcon } from '../assets/icons/TasksIcon'
import { IndustriesIcon } from 'assets/icons/IndustriesIcon'
import { CompaniesIcon } from 'assets/icons/CompaniesIcon'
import { SettingsIcon } from 'assets/icons/SettingsIcons'
import { arrowsIcon } from 'assets/icons/Arrows'
import { financesIcon } from 'assets/icons/financesIcon'
import { WorkflowIcon } from 'assets/icons/WorkflowIcon'
import { FoldMapIcon } from 'assets/icons/FoldMapIcon'
import { DashboardIcon } from 'assets/icons/DashboardIcon'
import { FuelSidebarIcon } from 'assets/icons/FuelSidebarIcon'
import { CompanyAdminIcon } from 'assets/icons/CompanyAdminIcon'
import { employeesIcon } from 'assets/icons/EmployeesIcon'
import { roleIcon } from 'assets/icons/RoleIcon'
import { shiftsIcon } from 'assets/icons/ShiftsIcon'
import { SuitcaseIcon } from 'assets/icons/SuitcaseIcon'
import { FoodIcon } from 'assets/icons/FoodIcon'
import { AccomodationIcon } from 'assets/icons/AccomodationIcon'
import { TransportationIcon } from 'assets/icons/TransportationIcon'
import { PayrollsIcon } from 'assets/icons/PayrollsIcon'
import { FileIcon } from 'assets/icons/FileIcon'
import { procurementIcon } from 'assets/icons/ProcurementIcon'
import { OrganogramIcon } from 'assets/icons/OrganogramIcon'

export const linksClient: ILink[] = [
  {
    path: '/dashboard',
    id: 1111,
    text: 'Dashboard',
    icon: DashboardIcon,
    abr: 'dashboard',
  },
  {
    path: '/organogram',
    id: 1113,
    text: 'Organogram',
    icon: OrganogramIcon,
    abr: 'organogram',
  },
  {
    path: '/global-view',
    id: 1,
    text: 'AIM Vision',
    icon: FoldMapIcon,
    abr: 'aimVision',
  },
  {
    path: '/hr/dashboard',
    id: 11112,
    text: 'HR',
    icon: employeesIcon,
    abr: 'hr',
    list: [
      { name: 'Dashboard', path: 'hr/dashboard', icon: DashboardIcon },
      { name: 'Analytics', path: 'hr/analytics', icon: financesIcon },
      { name: 'Employees', path: 'hr/employees', icon: employeesIcon },
      { name: 'Schedule', path: 'hr/schedule', icon: shiftsIcon },
      { name: 'Attendance', path: 'hr/attendance', icon: shiftsIcon },
      { name: 'Accommodation', path: 'hr/accommodation', icon: AccomodationIcon },
      { name: 'Food', path: 'hr/food', icon: FoodIcon },
      { name: 'Payrolls', path: 'hr/payrolls', icon: PayrollsIcon },
      { name: 'Roles', path: 'hr/roles', icon: roleIcon },
      { name: 'Departments', path: 'hr/departments', icon: SuitcaseIcon },
      // { name: 'Transportation', path: 'hr/transportation', icon: TransportationIcon },
    ],
  },
  {
    path: '/fuel/dashboard',
    id: 123,
    text: 'Fuel',
    icon: FuelSidebarIcon,
    abr: 'fuel',
    list: [
      { name: 'Dashboard', path: '/fuel/dashboard', icon: DashboardIcon },
      { name: 'Losses', path: '/fuel/losses', icon: DashboardIcon },
      { name: 'Tanks', path: '/fuel/tanks', icon: TransportationIcon },
      { name: 'Suppliers', path: '/fuel/suppliers', icon: inventoryIcon },
    ],
  },
  {
    path: '/machinery/fleet',
    id: 5,
    text: 'Fleet',
    icon: machineryIcon,
    abr: 'machinery',
  },
  // Procurement
  {
    path: '/procurement',
    id: 988,
    text: 'Procurement',
    icon: procurementIcon,
    abr: '*',
  },
  {
    path: '/inventory/dashboard',
    id: 6,
    text: 'Inventory',
    list: [
      { name: 'Dashboard', path: '/inventory/dashboard', icon: DashboardIcon },
      { name: 'Items', path: '/inventory/items', icon: inventoryIcon },
      { name: 'Requests', path: '/inventory/requests', icon: FileIcon },
      { name: 'Suppliers', path: '/inventory/supliers', icon: IndustriesIcon },
      { name: 'Cost Center', path: '/inventory/cost-center', icon: financesIcon },
      { name: 'Receipts', path: '/inventory/receipts', icon: FileIcon },
      { name: 'Issues', path: '/inventory/issues', icon: FileIcon },
      { name: 'Transfers', path: '/inventory/transfers', icon: arrowsIcon },
    ],
    icon: inventoryIcon,
    abr: 'inventory',
  },
  {
    id: 2,
    path: '/operations',
    text: 'Operations',
    abr: 'operations',
    icon: NutIcon,
    list: [
      { name: 'Operation Groups', path: '/operations', icon: NutIcon },
      { name: 'Capabilities', path: '/operations/capabilities', icon: DashboardIcon },
      { name: 'Issues', path: '/operations/issues', icon: issuesIcon },
    ],
  },

  {
    id: 222,
    path: '/ops-control',
    text: 'Ops Control',
    abr: 'ops',
    icon: SettingsIcon,
    list: [
      { name: 'Dashboard', path: '/ops-control', icon: DashboardIcon },
      { name: 'Plan List', path: '/ops-control/plans', icon: NutIcon },
      { name: 'Dept. Board', path: '/ops-control/department', icon: NutIcon },
      { name: 'Shift Programs', path: '/ops-control/shift-programs', icon: NutIcon },
      { name: 'Triggers', path: '/ops-control/triggers', icon: arrowsIcon },
    ],
  },
  {
    id: 888789,
    path: '/configurations/task-templates',
    text: 'Configurations',
    icon: TasksIcon,
    abr: 'configurations',
    list: [
      { name: 'Templates', path: '/configurations/task-templates', icon: TasksIcon },
      { name: 'Worker Components', path: '/configurations/tasks-worker-components', icon: NutIcon },
      { name: 'Workflows', path: '/configurations/workflows', icon: WorkflowIcon },
      { name: 'Issue Triggers', path: '/configurations/triggers-issue', icon: arrowsIcon },
      { name: 'Task Triggers', path: '/configurations/triggers-task', icon: arrowsIcon },
    ],
  },
  {
    path: '/resources/locations',
    id: 66,
    text: 'Resources',
    icon: locationsIcon,
    abr: 'resources',
    list: [
      { name: 'Locations', path: '/resources/locations' },
      { name: 'Zones', path: '/resources/zones' },
    ],
  },

  {
    path: '/analytics',
    id: 11,
    text: 'Analytics',
    icon: financesIcon,
    list: [
      { name: 'Costs', path: '/analytics/costs' },
      { name: 'Reports', path: '/analytics/reports' },
    ],
    abr: 'analytics',
  },
]

export const locations = [
  {
    id: 1,
    title: 'Luxembourg',
    address: '3, Place De Clairefontaine, L-1341 Luxembourg',
    phone: '(406) 555-0120',
    email: 'atfdubai@atf.com',
    coordinates: {
      lat: 49.61019,
      lng: 6.13283,
    },
  },
]

export const linksAdmin: ILink[] = [
  {
    id: 3,
    path: '/resources-models',
    text: 'Resources',
    list: [
      { name: 'Models', path: '/resources-models' },
      { name: 'Fields', path: '/resources-fields' },
      { name: 'Categories', path: '/resources-categories' },
      { name: 'Roles', path: '/resources-role-templates' },
    ],
    icon: FolderIcon,
  },

  {
    id: 4,
    path: '/company-admins',
    text: 'Company Admins',
    icon: CompanyAdminIcon,
  },
  {
    id: 5,
    path: '/companies',
    text: 'Companies',
    icon: CompaniesIcon,
  },

  {
    id: 6,
    path: '/inventory-fields',
    text: 'Inventory',
    icon: SettingsIcon,
    list: [
      { name: 'Fields', path: '/inventory-fields' },
      { name: 'Categories', path: '/inventory-categories' },
    ],
  },
  {
    id: 7,
    path: '/industries',
    text: 'Industries',
    icon: IndustriesIcon,
  },

  // {
  //   id: 8,
  //   path: '/cycles',
  //   text: 'Cycles',
  //   icon: CycleIcon,
  // },

  // {
  //   id: 11,
  //   path: '/process-templates',
  //   text: 'Processes',
  //   icon: ProcessTemplateIcon,
  // },
]

export interface ILink {
  id: number
  path: string
  text: string
  abr?: string
  icon: JSX.Element
  list?: {
    name: string
    path: string
    icon?: JSX.Element
  }[]
}
